import React from "react";
import Image from "../Image";
import { Col } from "../Grid";

const WhatIsNewImage = ({ src, alt = "", ...props }) => {
	return (
		<Col sm={12} md={3} lg={3} spacing={{ mt: 10 }} sx={{ textAlign: "center" }}>
			<Image src={src} alt={alt} {...props} />
		</Col>
	);
};

WhatIsNewImage.propTypes = {
	...Image.propTypes,
};

export default WhatIsNewImage;
